<script>
    import { getContext } from "svelte";
    const { close } = getContext("modal");
    import { langTextStore } from "../store/langtexts.js";

    export let confirmAction = () => {};
    export let titleLangKey = "general-label-are-you-sure";
    export let contentLangKey = "general-label-are-you-sure-content";
    export let cancelButtonTextOverrideLangKey;
    export let actionButtonTextOverrideLangKey;
    $: cancelButtontext = $langTextStore.getText(
        cancelButtonTextOverrideLangKey || "general-label-no"
    );
    $: actionButtontext = $langTextStore.getText(
        actionButtonTextOverrideLangKey || "general-label-yes"
    );

    $: titleText = $langTextStore.getText(titleLangKey);
    $: contentText = $langTextStore.getText(contentLangKey);
    $: isTextLoaded = titleText.length > 0;
</script>

<div class="modal-header">
    <h2 class="gray-6 mt-3 mb-5"> {$langTextStore && titleText}</h2>
</div>
<div class="modal-body">
    {$langTextStore && contentText}
</div>
<div class="modal-footer pt-5">
    <div class="w-100 text-right mt-4 mb-3">
        <button type="button" class="btn btn-gray width-unset " on:click={close}>{$langTextStore && cancelButtontext}</button> 
        <button type="button" class="btn btn-primary width-unset" on:click={() => {
            confirmAction();
            close();
        }}>{$langTextStore && actionButtontext}</button></div>
    
</div>

<svelte:head>
    <style>
        .close {
            display: none !important;
        }
    </style>
</svelte:head>
